module.exports = __webpack_public_path__ + "img/Starling.efd8cb0f.png";